import Footer from "./Footer";
import Header from "./Header";
import Button from 'react-bootstrap/Button';
import React, { useRef } from "react";


const Login = () => {
    const password = useRef();
    const id = useRef();

    function pass() {
        // let navigate = useNavigate();
        let idVal = id.current.value;
        let pwVal = password.current.value;
        let idName = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
        let reg = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/;

        if (false === idName.test(idVal)) {
            alert('아이디를 다시 입력해주세요.');
            return false;
        } else {
            if (false === reg.test(pwVal)) {
                alert('비밀번호는 8자 이상, 숫자/대문자/소문자/특수문자를 모두 포함해야 합니다.');
                return false;
            } else if (/(\w)\1\1\1/.test(pwVal)) {
                alert('같은 문자를 4번 이상 사용할 수 없습니다.');
                return false;
            } else if (pwVal.search(idVal) > -1) {
                alert('비밀번호에 아이디가 포함될 수 없습니다.');
                return false;
            } else if (pwVal.search(/\s/) != -1) {
                alert('비밀번호는 공백 없이 입력해주세요.');
                return false;
            } else {
                alert('로그인 되었습니다.');
                return true;
            }
        }
    }

    return (

        <div>
            <Header></Header>

            <div className="login_wrap">
                <div>
                    <input type="text" placeholder="아이디(abc@mail.com)" ref={id}/>
                </div>
                <div>
                    <input type="password" placeholder="비밀번호" ref={password}/>
                </div>
                <Button variant="dark" onClick={()=>{pass()}}>로그인</Button>
                <span>아이디/비밀번호 찾기</span>
            </div>


            <Footer></Footer>
        </div>
    )
}
export default Login;